
//  Link media
require.context('../media/', true, /^\.\/.*\.*/);
require.context('../fonts/', true, /^\.\/.*\.*/);

require('core-js/fn/array/from');

//  Styles
import '../styles/styles.scss';

// JS


import lazysizes from 'lazysizes';

import $ from 'jquery';
import Waypoint from 'Waypoint';
import utils from './proj/utils';



$(document).ready(function(){




  const animSpeed = 0.2;

  let els = [...document.querySelectorAll('.block-content-inner')];

  const sortByPos = ( x, y ) => {
    let xBox = x.getBoundingClientRect();
    let yBox = y.getBoundingClientRect();
    return xBox.top - yBox.top || xBox.left - yBox.left;
  }

  const reducer = (acc, cur) => {
    let x = cur.getBoundingClientRect().left;

    if( x <= acc.x) {
      // new row
      acc.x = 0;
      acc.index = 0;
    }

    $(cur).css('animation-delay', (acc.index * animSpeed) + 's' );

    acc.index++;
    acc.x = x;

    return acc;
  }

  const sortedByPos = els.sort( sortByPos );

  const sortedByRows = sortedByPos.reduce( reducer, { x: 0, index: 0 } );



  let blocks = $('.block-content-inner');
  let waypoints = [];

  $.each( blocks, function(idx, el) {

			// container enters viewport (scrolling down) or leaves viewport (scrolling back up)
			waypoints.push(
				new Waypoint({
				  element: el,
				  handler: function(direction) {
				  	var $el = $(el);
            $el.addClass('a-reveal-up-in');
            this.destroy();
				  },
				  offset: '90%'
				})
			);

  });

  let hasScrolled = false;
  let $header = $('.header');


  const resizeHeader = function(w,h) {
    let initialWidth = w;
    let initialHeight = h;

    return function() {
      const landscape = window.innerWidth > window.innerHeight;
      if( utils.mobileAndTabletCheck() && initialHeight > 100  ) {
        const newH = ( window.innerWidth === initialWidth ) ? initialHeight : initialWidth;
        $header.css( { height: newH + 'px'} );
      }
    }

  }( window.innerWidth, window.innerHeight );

  resizeHeader();

  $.each( $header, function(idx, el) {
    // minimize royal couple area
    waypoints.push(
      new Waypoint({
        element: el,
        handler: function(dir) {
          var $el = $(el);
          if( dir === 'down') {
            $el.removeClass('prompt-to-scroll');
            this.destroy();
            hasScrolled = true;
          }

        },
        offset: -10
      })
    );
  });

  setTimeout( function() {
    if( !hasScrolled ) {
      $header.addClass('prompt-to-scroll');
    }
  }, 3000);

  $( window ).on( "orientationchange", function( event ) {
    resizeHeader();
  });


});



// WEBPACK FOOTER //
// ./src/js/main.js